module.exports = __webpack_public_path__ + "static/img/result_list.326596d0.png";